var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    { staticClass: "custom-fields-list fs-13" },
    _vm._l(_vm.customFieldDefinitions, function(customFieldDefinition) {
      return _c(
        "li",
        { key: customFieldDefinition.path, staticClass: "custom-field" },
        [
          _c("custom-field-label", {
            staticClass: "text-color--dark-gray",
            attrs: { "custom-field-definition": customFieldDefinition }
          }),
          _vm._v(" "),
          _c("custom-field-value", {
            attrs: {
              "custom-field-definition": customFieldDefinition,
              "custom-fields": _vm.customFields
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }